<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="TocSb1" id="pre"><a id="page_vii"></a><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="Toc" id="int"><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="Toc" id="ch-001"><a href="#/xhtml/chapter001#ch001">Cycle I: The Last Judge (1 Samuel 1–12)</a></p>
<p class="Toc" id="ch-002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">Cycle II: A King on His Throne (1 Samuel 13–31)</span></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">Cycle III: Ascent to Kingship (2 Samuel 1–8)</span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">Cycle IV: A King and His People (2 Samuel 9–20)</span></p>
<p class="Toc" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">Cycle V: Hazards, Heroes, and Poetry (2 Samuel 21–24)</span></p>
<p class="Toc2" id="app"><span href="#/xhtml/appendix#app" title="Link target outside of Sample">Appendix: Hebrew Words in This Volume</span></p>
<p class="Toc1" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="Toc1" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Author Index</span></p>
<p class="Toc1" id="idx-002"><span href="#/xhtml/index002#idx002" title="Link target outside of Sample">Subject Index</span></p>
<p class="Toc1" id="idx-003"><span href="#/xhtml/index003#idx003" title="Link target outside of Sample">Scripture Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1c4c31be